import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('contractFile', 'contractFiles');

const customActions = {
  async LOAD_contractFilesByContractId({ commit, rootGetters }, contractId) {
    const data = await odata.o(rootGetters)
      .get('contractFiles')
      .query({ $filter: `IsDeleted eq false AND ContractId eq ${contractId}` });
    commit('SET_contractFile', data);
    return data;
  },
};

export default { ...actions, ...customActions };
